import { render, staticRenderFns } from "./AccountBalance.vue?vue&type=template&id=7a4b1c06&scoped=true&"
import script from "./AccountBalance.vue?vue&type=script&lang=ts&"
export * from "./AccountBalance.vue?vue&type=script&lang=ts&"
import style0 from "./AccountBalance.vue?vue&type=style&index=0&id=7a4b1c06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4b1c06",
  null
  
)

export default component.exports